import { FilterButton } from '../../../../components/buttons/FilterButton';
import { useTranslation } from 'react-i18next';
import { DEFAULT_DATE_TIME } from '../../../../components/common/Constants';
import { toDateString } from '../../../../utils/TimeUtils';
import { DateTimePicker } from '../../../../components/dateTimePicker/DateTimePicker';

export const WarehouseFilter = ({ filter, doFilter }) => {
    const { t } = useTranslation();

    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            doFilter();
        }
    };

    const setFrom = (value) => {
        filter.from = toDateString(value, DEFAULT_DATE_TIME);
    };

    const setTill = (value) => {
        filter.till = toDateString(value, DEFAULT_DATE_TIME);
    };

    return (
        <div className={'filter'} id={'filter-element'}>
            <div className={'mb-3'}>
                <span>{t('filter:title')}</span>
                <input type={'text'}
                       className={'form-control'}
                       id={'filter-by-title-id'}
                       defaultValue={filter.title}
                       onKeyUp={handleKeyUp}
                       onChange={(e) => filter.title = e.target.value} />
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:invoice')}</span>
                <input type={'text'}
                       className={'form-control'}
                       id={'filter-by-invoice-id'}
                       defaultValue={filter.invoice}
                       onKeyUp={handleKeyUp}
                       onChange={(e) => filter.invoice = e.target.value} />
            </div>
            <div className={'mb-3'}>
                <span>{t('warehouse:invoiceDate')} {t('filter:from')}</span>
                <DateTimePicker value={filter.from}
                                onChange={setFrom}
                                dateFormat={DEFAULT_DATE_TIME}
                                showTime={true}>
                </DateTimePicker>
            </div>
            <div className={'mb-3'}>
                <span>{t('warehouse:invoiceDate')} {t('filter:till')}</span>
                <DateTimePicker value={filter.till}
                                onChange={setTill}
                                dateFormat={DEFAULT_DATE_TIME}
                                showTime={true}>
                </DateTimePicker>
            </div>
            <div className={'center'}>
                <FilterButton onClick={doFilter}></FilterButton>
            </div>
        </div>
    );
};